<template>
  <div id="driver" :class="['app-container', { 'bdc-list-page': isBdc }]">
    <!-- 筛选工具 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <el-button v-if="!isBdc && isShow&&all_or_manage" id="CreateGame-Guide" class="filter-item" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="adddivshow">创建游戏</el-button>

      <!-- <el-button class="filter-item" size="small" icon="el-icon-bangzhu" @click="handleTf" v-if="isAdsShow">广告投放平台</el-button>
      <el-button class="filter-item" size="small" icon="el-icon-position" @click="handleZz" v-if="isAdsShow" style="margin-left:0">广告增值平台</el-button> -->
      <el-input v-model="gnames" class="filter-item" size="small" clearable placeholder="游戏名模糊查询" style="width:200px;" />
      <el-input v-model="yyfname" class="filter-item" size="small" clearable placeholder="运营方模糊查询" style="width:200px;" />
      <el-input v-if="isAdmin_Vip" v-model="gknames" class="filter-item" size="small" clearable placeholder="GameKey模糊查询" style="width:200px;" />
      <el-input v-if="isAdmin_Vip" v-model="knames" class="filter-item" size="small" clearable placeholder="AppKey模糊查询" style="width:200px;" />
      <el-select v-model="gameNode" class="filter-item" size="small" placeholder="游戏节点" clearable @change="gameNodechange">
        <el-option value="0" label="上线" />
        <el-option value="4" label="测试" />
        <el-option value="2" label="下线" />
        <el-option value="1" label="节点时间需完善" />
        <el-option value="3" label="项目终止" />

      </el-select>

      <!-- table header 筛选 -->
      <div v-if="!isBdc" class="filterTableHeader" style="float:right;">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom" /></el-button>
          <el-checkbox-group v-model="checkboxTitle" class="checkbox-table-headers">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{ item[Object.keys(item)[0]] }}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
      <div v-if="isBdc" class="filterTableHeader bdc-list-toolbar-actions">
        <el-button v-if="isShow&&all_or_manage" id="CreateGame-Guide" class="filter-item" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="adddivshow">创建游戏</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table v-loading="listLoading" class="grayTableTile" :data="tableList" border style="width: 100%" :height="tableHeightDaily" @sort-change="handleAgeSortChange">
      <el-table-column min-width="140px" sortable="custom" prop="name">
        <template slot="header">
          <span id="GameName-Guide">游戏名称</span>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.auditStatus == 1" style="color:#646cf5;cursor: pointer;" @click="jinruyouxi(scope.row)">{{ scope.row.productName }}</span>
          <span v-else>{{ scope.row.productName }}</span>
        </template>
      </el-table-column>

      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :sortable="Object.keys(item)[0] == 'operateStudio' || Object.keys(item)[0] == 'gameNode' ? 'custom' : false" :min-width="Object.keys(item)[0] == 'appkey' ? '140px' : '120px'">
        <template slot-scope="scope">
          <!-- sdk 版本 -->
          <template v-if="Object.keys(item)[0] == 'sdkVersion'">
            <el-popover v-if="scope.row.sdkVersion.clientSdk" placement="right" width="700" trigger="click">
              <div style="font-size: 16px;font-weight: 600;margin-bottom: 10px;">{{ `SDK版本-${scope.row.productName}-客户端` }}</div>
              <el-table v-loading="sdkloading" :data="sdkVersionList" height="400px">
                <el-table-column property="clientOs" label="sdk类型" min-width="120px" />
                <el-table-column property="channelName" label="渠道名" min-width="130px">
                  <template slot="header" slot-scope="scope">
                    <el-input v-model="search" size="mini" placeholder="输入sdk类型或渠道搜索" />
                  </template>
                </el-table-column>
                <el-table-column property="sdkVersion" label="版本号" min-width="100px" />
                <el-table-column property="buessDate" label="更新时间" min-width="120px" />
              </el-table>
              <div slot="reference" class="table-sdk" @click="sdkVersiondatalist(scope.row, 'CLIENT')"><svg-icon icon-class="client" style="width: 20px;height: 20px;margin-right: 4px;" />{{ scope.row.sdkVersion.clientSdk }}</div>
            </el-popover>
            <el-popover v-if="scope.row.sdkVersion.serverSdk" placement="right" width="700" trigger="click">
              <div style="font-size: 16px;font-weight: 600;margin-bottom: 10px;">{{ `SDK版本-${scope.row.productName}-服务端` }}</div>
              <el-table v-loading="sdkloading" :data="sdkVersionList" height="400px">
                <el-table-column property="sdkType" label="sdk类型" min-width="130px">
                  <template slot="header" slot-scope="scope">
                    <el-input v-model="sdkTypeSearch" size="mini" placeholder="输入sdk类型查询" />
                  </template>
                </el-table-column>
                <el-table-column property="sdkVersion" label="版本号" min-width="100px" />
                <el-table-column property="buessDate" label="更新时间" min-width="120px" />
              </el-table>
              <div slot="reference" class="table-sdk" @click="sdkVersiondatalist(scope.row, 'SERVER')"><svg-icon icon-class="server" style="width: 20px;height: 20px;margin-right: 4px;" />{{ scope.row.sdkVersion.serverSdk }}</div>
              <!-- <el-button slot="reference" type="text" style="padding:0px" @click="sdkVersiondatalist(scope.row)">{{ scope.row[Object.keys(item)[0]] }}</el-button> -->
            </el-popover>
            <span v-if="!scope.row.sdkVersion.clientSdk && !scope.row.sdkVersion.serverSdk">暂无</span>
          </template>

          <span v-else-if="Object.keys(item)[0] == 'cooperateType'">{{ scope.row[Object.keys(item)[0]] | cooperateTypeFilter }}</span>
          <span v-else-if="Object.keys(item)[0] == 'gameNode'">
            <el-button type="text" style="font-size: 12px;padding:0px;color: #3A89FF" @click="showGameNodeList(scope.row)">{{ scope.row[Object.keys(item)[0]] }}</el-button>
          </span>
          <span v-else> {{ scope.row[Object.keys(item)[0]] }}</span>
        </template>
      </el-table-column>

      <!--状态 -->
      <el-table-column v-if="isShow" min-width="100px" sortable="custom" prop="auditStatus">
        <template slot="header">
          <span id="GameStatus-Guide">状态</span>
        </template>
        <template slot-scope="scope">
          <!-- 新逻辑 -->
          <div v-if="[1, 2].includes(scope.row.auditStatus)" style="display: flex;align-items: center;">
            <svg-icon :icon-class="scope.row.auditStatus == 1 ? 'success' : 'error'" style="width:16px;height:16px;margin-right: 4px;" /><span :style="{'color': scope.row.auditStatus == 1 ? '#24915A' : '#E22B4B', 'cursor': 'pointer'}" @click="examineGameStatus(scope.row)">{{ scope.row.auditStatus | statusFilter }}</span>
          </div>
          <div v-else-if="[4 ,5].includes(scope.row.auditStatus)" style="display: flex;align-items: center;">
            <svg-icon icon-class="info" style="width:16px;height:16px;margin-right: 4px;" /><span style="color: #999999;cursor: pointer;" @click="examineGameStatus(scope.row)">{{ scope.row.auditStatus | statusFilter }}</span>
          </div>
          <div v-else style="display: flex;align-items: center;">
            <svg-icon icon-class="info" style="width:16px;height:16px;margin-right: 4px;" /><span style="color: #999999;">{{ scope.row.auditStatus | statusFilter }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShow && all_or_manage" width="180px">
        <template slot="header">
          <span id="EditGame-Guide">操作</span>
        </template>
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button v-if="scope.row.isUpdate == 1" type="text" class="bdc-table-op-muted" @click="allbianjiyouxi(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.isUpdate != 1" type="text" class="bdc-table-op-muted" @click="lookyouxi(scope.row)">详情</el-button>
            <el-button v-if="scope.row.isDel == 1" type="text" class="bdc-table-op-danger" @click="handleDelete(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="isShow && !all_or_manage" width="180px">
        <template slot="header">
          <span id="EditGame-Guide">操作</span>
        </template>
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-muted" @click="bianjiyouxi(scope.row)">编辑</el-button>
            <el-button type="text" class="bdc-table-op-danger" @click="handleDelete(scope.row)">删除</el-button>
            <el-popover placement="top" width="200" trigger="hover" @after-enter="editPopoverShow(scope.row.id)" @hide="editPopoverHide(scope.row.id)">
              <el-checkbox-group v-model="checkList[scope.row.id]">
                <el-checkbox style=" margin-bottom: 5px" label="bdc">BDC（运营数据平台）</el-checkbox>
                <el-checkbox style=" margin-bottom: 5px" label="ads">ADS（广告监测平台）</el-checkbox>
                <el-checkbox style=" margin-bottom: 5px" label="gms">GMS（客服查询平台）</el-checkbox>
                <el-checkbox style=" margin-bottom: 5px" label="adv">ADV（广告投放平台）</el-checkbox>
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 5px">
                <el-button type="primary" size="mini" @click="updatecheckList(scope.row,checkList[scope.row.id])">确定</el-button>
              </div>
              <el-button v-if="isAdmin_Vip" slot="reference" type="text" class="bdc-table-op-muted">管理</el-button>
            </el-popover>
          </div>
        </template>

      </el-table-column>
    </el-table>
    </div>
    <!-- 分页 -->
    <bdc-table-footer>
      <template #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group v-model="checkboxTitle" class="checkbox-table-headers">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{ item[Object.keys(item)[0]] }}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" />
    </bdc-table-footer>
    <!-- 添加、修改、审核游戏 -->
    <create-game ref="create" @getAgainList="getList" />

    <el-dialog class="dialog" :close-on-click-modal="false" :title="gameNodeTitle" :visible.sync="gameNodeShow" width="96%" top="5vh">
      <game-node ref="gameNode" @timeCallback="timeCallback" />
    </el-dialog>

    <el-dialog class="dialog" :close-on-click-modal="false" title="提示" :visible.sync="sdkTypeShow" width="
    350px">
      <div>未配置 “登录SDK”，请先进行配置！</div>
      <div style="margin-top:20px"><span style="color:#ff0000">*</span>登录SDK：
        <el-select v-model="selectSdkType" placeholder="SDK类型" size="small" style="width:228px">
          <el-option label="全球SDK" :value="1" />
          <el-option label="USDK" :value="2" />
          <el-option label="其他" :value="3" />
        </el-select>
      </div>

      <div class="dialog-butn-box" style="margin-top:20px">
        <el-button @click="sdkTypeShow = false">取消</el-button>
        <el-button type="primary" @click="submitsdkType">确定</el-button>
      </div>
    </el-dialog>

    <game-status ref="gameStatusRef" />

  </div>
</template>

<script>
import { gamelist, detail_sdk, deletegame, ajax_gamesystem, updateSdkType } from '@Sys~/api/sys'
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { arrSlice, sortKeys } from '@/filters'
import CreateGame from './components/createGame'
import Store from '@Sys~/store'
import GameNode from './components/gameNode.vue'
import gameStatus from './components/gameStatus.vue'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'

const defaultFormThead = [
  { operateStudio: '运营方' },
  { id: 'ID' },
  { gameKey: 'GameKey' },
  { appkey: 'AppKey' },
  { cooperateType: '合作方式' },
  { gameNode: '游戏节点' },
  { sdkVersion: 'SDK版本' }
]

const defaultChecked = [
  { operateStudio: '运营方' },
  { cooperateType: '合作方式' },
  { gameNode: '游戏节点' },
  { sdkVersion: 'SDK版本' }
]
const name = Store.getters.currentRoute.name
// console.log('缓存===',Store.getters.currentRoute.meta.title, name)
export default {
  name: name,
  mixins: [bdcListTableHeight],
  components: { Pagination, BdcTableFooter, BdcColumnFilterButton, CreateGame, GameNode, gameStatus },

  filters: {
    // 合作方式
    cooperateTypeFilter(type) {
      const typeMap = {
        1: '自研',
        2: '代理'
      }
      return typeMap[type]
    },

    // 状态
    statusFilter(status) {
      const statusMap = {
        // 0: '审核',
        // 1: '可查看',
        // 2: '未通过'
        0: '审核中',
        1: '审核通过',
        2: '未通过',
        3: '分析师待审核',
        4: '服务端待审核',
        5: '大数据待审核'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      currentGame: {},
      selectSdkType: null,
      sdkTypeShow: false,
      all_or_manage: true,
      isShow: process.env.VUE_APP_PROJECT_TYPE == 'bdc',
      isAdsShow: process.env.VUE_APP_PROJECT_TYPE == 'ads',
      gnames: '',
      yyfname: '',
      gknames: '',
      knames: '',
      gameNode: '',

      gameNodeTitle: '', // 时间节点title
      gameNodeShow: false, // 显示时间节点列表

      // 表格
      listLoading: false,
      originalCaseTable: [], // 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions: defaultFormThead,
      checkboxTitle: defaultChecked,
      tableTheads: defaultChecked,

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },
      sortQuery: {
        prop: '',
        order: ''
      },

      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,

      sdkVersiondata: [],
      sdkloading: false,
      search: '',
      sdkTypeSearch: '', // 服务端sdk类型搜索
      checkList: {},

      editCheckGame: {}, // 管理时临时保存游戏
      handleEdit: false // 管理页面弹出后是否点击确定
    }
  },

  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },

    // 筛选列表表
    tableList() {
      console.log('变化')
      let caseTable = this.caseTable
      const gnames = this.gnames.toLowerCase().replace(/\s+/g, '')
      const yyfname = this.yyfname.toLowerCase().replace(/\s+/g, '')
      const gknames = this.gknames.toLowerCase().replace(/\s+/g, '')
      const knames = this.knames.toLowerCase().replace(/\s+/g, '')
      if (gnames || yyfname || gknames || knames) {
        caseTable = this.caseTable.filter(data => {
          return (String(data['productName']).toLowerCase().indexOf(gnames) > -1 || String(data['pinyinQp']).toLowerCase().indexOf(gnames) > -1 || String(data['pinyinSx']).toLowerCase().indexOf(gnames) > -1) &&
            String(data['devParty']).toLowerCase().indexOf(yyfname) > -1 &&
            String(data['gameKey']).toLowerCase().indexOf(gknames) > -1 &&
            String(data['appkey']).toLowerCase().indexOf(knames) > -1
        })
      }

      this.total = caseTable.length
      // 将一维数组切割成二维数组
      this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
      this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
      if (this.tableData) {
        this.tableData.map(e => {
          if (e.systemName == '') {
            this.$set(this.checkList, e.id, [])
          } else {
            this.$set(this.checkList, e.id, e.systemName.split(','))
          }
        })
      }
      return this.tableData
    },

    // 筛选sdk版本详情列表
    sdkVersionList() {
      const search = this.search.toLowerCase().replace(/\s+/g, '')
      const sdkTypeSearch = this.sdkTypeSearch.toLowerCase().replace(/\s+/g, '')

      if (search) {
        return this.sdkVersiondata.filter(data => {
          // return Object.keys(data).some(key => {
          return String(data['clientOs']).toLowerCase().indexOf(search) > -1 || String(data['channelName']).toLowerCase().indexOf(search) > -1
          // })
        })
      }
      if (sdkTypeSearch) {
        return this.sdkVersiondata.filter(data => {
          // return Object.keys(data).some(key => {
          return String(data['sdkType']).toLowerCase().indexOf(sdkTypeSearch) > -1
          // })
        })
      }
      return this.sdkVersiondata
    }
  },

  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },

  created() {
    if (this.$route.name == 'quanbuyouxi' || this.$route.name == 'ads_track') {
      this.all_or_manage = true
    } else if (this.$route.name == 'game_manage') {
      this.all_or_manage = false
    }
    this.getList()
  },
  mounted() {
    this.checkboxTitle = []
    var theads = defaultFormThead
    theads.forEach(item => {
      if (item[Object.keys(item)[0]] == 'ID' || item[Object.keys(item)[0]] == 'GameKey' || item[Object.keys(item)[0]] == 'AppKey') {

      } else {
        this.checkboxTitle.push(item)
      }
    })
  },

  methods: {
    gameNodechange() {
      this.getList()
    },
    // 获取游戏列表
    getList() {
      this.listLoading = true
      gamelist(this.gameNode, !this.all_or_manage).then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data
          this.originalCaseTable = JSON.parse(JSON.stringify(response.data))
          this.handleAgeSortChange(this.sortQuery)
        }
      })
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      this.sortQuery.order = e.order
      this.sortQuery.prop = e.prop
      if (e.order) {
        const order = e.order != 'descending'
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 跳转到游戏
    jinruyouxi(row) {
      this.$store.dispatch('game/setAppkey', row.appkey)
      // window.sessionStorage.setItem('appkey', row.appkey)
      document.cookie = 'appkey=' + row.appkey + '; domain=.yingxiong.com; path=/'

      if (process.env.VUE_APP_PROJECT_TYPE == 'bdc') {
        if (process.env.VUE_APP_TITLE === 'stage') { // 测试环境
          window.open('https://test-bdc4.yingxiong.com/info/')
        } else {
          window.open('https://bdc4.yingxiong.com/info/')
        }
      } else if (process.env.VUE_APP_PROJECT_TYPE == 'gms') {
        if (process.env.VUE_APP_TITLE === 'stage') { // 测试环境
          window.open('https://test-gms.yingxiong.com/info/')
        } else {
          window.open('https://gms.yingxiong.com/info/')
        }
      }
    },

    // 审核游戏状态
    examineGameStatus(row) {
      console.log(row)
      this.$refs.gameStatusRef.init(row)
    },

    // 投放平台跳转
    handleTf() {
      window.open('')
    },

    // 增值平台跳转
    handleZz() {
      window.open('')
    },

    // 版本详情
    sdkVersiondatalist(row, type) {
      this.sdkloading = true
      this.sdkVersiondata = []
      this.search = ''
      this.sdkTypeSearch = ''
      detail_sdk({ appkey: row.appkey, platform: type }).then(response => {
        this.sdkloading = false
        if (response.code == 1) {
          this.sdkVersiondata = response.data
        }
      })
    },
    showGameNodeList(row) {
      this.currentGame = row
      if ((row.sdkType == null || !row.sdkType) && (row.gameNode.indexOf('下线') == -1) && (row.gameNode.indexOf('上线') == -1) && this.all_or_manage == false) {
        this.sdkTypeShow = true
        this.selectSdkType = null
      } else {
        this.gameNodeTitle = row.productName// 时间节点title
        this.gameNodeShow = true// 显示时间节点列表
        this.$nextTick(() => {
          this.$refs['gameNode'].createNodeInit(row.appkey, row.productName)
        })
      }
    },
    submitsdkType() {
      if (this.selectSdkType && this.selectSdkType != null) {
        updateSdkType({ id: this.currentGame.id, sdkType: this.selectSdkType }).then(response => {
          if (response.code == 1) {
            this.$message.success('更新成功！')
            this.getList()
            this.sdkTypeShow = false
          }
        })
      } else {
        this.$message.error('请选择SDK类型')
      }
    },

    // 游戏时区返回
    timeCallback(name) {
      this.gameNodeTitle = name
    },

    // 审核游戏
    shenhebtn(row) {
      this.$refs['create'].auditInit(row.id, this.all_or_manage)
    },

    lookyouxi(row) {
      console.log(row)
      this.$refs['create'].lookInit(row.id, this.all_or_manage)
    },

    // 创建游戏
    adddivshow() {
      this.$refs['create'].createInit(this.all_or_manage)
    },

    // 编辑游戏
    bianjiyouxi(row) {
      this.$refs['create'].editInit(row.id, this.all_or_manage)
    },
    allbianjiyouxi(row) {
      this.$refs['create'].alleditInit(row.id, this.all_or_manage)
    },

    // 删除游戏
    handleDelete(row) {
      this.$confirm('此操作将永久删除该游戏, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletegame({ id: row.id, auditStatus: row.auditStatus }).then(response => {
          if (response.code == 1) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    updatecheckList(row, arr) {
      console.log(this.checkList)
      console.log(row, arr.join(','))
      this.handleEdit = true
      ajax_gamesystem({
        'id': row.id, 'systemName': arr.join(',')
      }).then(response => {
        if (response.code == 1) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          })
          this.editCheckGame = this.checkList[row.id]
          this.handleEdit = false
        }
      })
    },

    // 编辑弹窗显示
    editPopoverShow(id) {
      this.handleEdit = false
      this.editCheckGame = this.checkList[id]
    },

    // 编辑弹窗隐藏
    editPopoverHide(id) {
      if (!this.handleEdit && (JSON.stringify(this.editCheckGame) != JSON.stringify(this.checkList[id]))) {
        this.checkList[id] = this.editCheckGame
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-sdk {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #3a89ff;
  & + .table-sdk {
    margin-top: 4px;
  }
}
</style>
